import { createStore } from 'effector';
import world from '../../data/world.json';

export const $worldPolygons = createStore(world.features);
$worldPolygons.watch((state) => console.log('$worldPolygons', state));

export const $currentCategory = createStore('100111');

export const $hsCodes = createStore([]);
